// Modules
import styled from 'styled-components';
// Styled Components
export const Header = styled.div`
  padding: 8px 16px;
`;
